import { useSelector } from 'react-redux'
import {
  selectBackgroundColor,
  selectCustomization,
  selectProfileColors
} from 'redux/selectors/Customization'

export const useBackgroundColor = () => {
  return useSelector(selectBackgroundColor)
}

export const useProfileColors = () => {
  return useSelector(selectProfileColors)
}

export const useCustomization = () => {
  return useSelector(selectCustomization)
}
